var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"app":"","color":"surface","elevation":"1","height":"64"}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-mini-menu')}}},[_c('v-icon',[_vm._v("fa-light fa-bars")])],1),_c('v-spacer'),_c('TheNotificationMenu'),_c('the-account-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }